export default __webpack_public_path__ + "static/media/address.3015b118.svg";